import {Observation} from './observation';

export class ObservationFilterUpdate {
  constructor(readonly observation: Observation|null,
              readonly source: string|null) {}
}
